import { ScreenProps } from "../Screen/Screen.interfaces";

const isScreenProps = (props: any): props is ScreenProps =>
  props !== undefined && typeof props.name === "string";

export default isScreenProps;
